// intervalsReducer.js

const initialState = {
  intervals: [],
  loading: false,
  error: null,
};

const CalenderReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_INTERVALS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_INTERVALS_SUCCESS":
      return {
        ...state,
        intervals: action.payload,
        loading: false,
        error: null,
      };
    case "FETCH_INTERVALS_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "ADD_INTERVAL_SLOT_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ADD_INTERVAL_SLOT_SUCCESS":
      return {
        ...state,
        intervals: [...state.intervals, action.payload],
        loading: false,
        error: null,
      };
    case "ADD_INTERVAL_SLOT_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "Reset_interval":
      return {
      ...state,
      intervals:[]
      };
    default:
      return state;
  }
};

export default CalenderReducer;
